import { render, staticRenderFns } from "./AddReportCustomComponentRel.vue?vue&type=template&id=a3dfa94a"
import script from "./AddReportCustomComponentRel.vue?vue&type=script&lang=js"
export * from "./AddReportCustomComponentRel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports